import PropTypes from "prop-types";
import React from "react";

const FieldLabel = ({ children, aside }) => (
  <span className="sl-field-label" style={{ justifyContent: aside ? "space-between" : "flex-start" }}>
    {children}{aside}
  </span>
);

FieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  aside: PropTypes.node,
};

FieldLabel.defaultProps = { aside: null };

export default FieldLabel;
